import React from 'react';
import { Box } from '@mui/material';
import { alpha, type Theme } from '@mui/material/styles';
import { HoldingHeaderProps } from '../types';
import FlyoutHeader from '../common/FlyoutHeader';
import { useLocalization } from '@/hooks/useLocalization';
import { brandedLinkColor } from '@/constants/styles';

const brandedLinkSx = {
  cursor: 'pointer',
  color: brandedLinkColor,
  textDecorationLine: 'underline',
  textDecorationThickness: '1px',
  textUnderlineOffset: '3px',
  textDecorationColor: (theme: Theme) => alpha(brandedLinkColor(theme), 0.45),
  '&:hover': {
    color: brandedLinkColor,
    textDecorationColor: brandedLinkColor,
  },
  '&:focus-visible': {
    borderRadius: 0.5,
    outline: (theme: Theme) =>
      `2px solid ${alpha(brandedLinkColor(theme), 0.55)}`,
    outlineOffset: '2px',
  },
};

const HoldingHeader: React.FC<HoldingHeaderProps> = ({
  holding,
  onClose,
  advisorContext,
}) => {
  const { t } = useLocalization();

  const handleClientNameKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      if (event.key === ' ') {
        event.preventDefault();
      }
      advisorContext?.onClientNameClick();
    }
  };

  const subtitle = advisorContext ? (
    <>
      <Box
        component='span'
        onClick={advisorContext.onClientNameClick}
        onKeyDown={handleClientNameKeyDown}
        role='button'
        tabIndex={0}
        sx={brandedLinkSx}
      >
        {advisorContext.clientName}
      </Box>
      {' - '}
      {holding.AccountName}
      {advisorContext.isAum === undefined
        ? ''
        : ` (${advisorContext.isAum ? t('AUM') : t('HeldAway')})`}
    </>
  ) : (
    holding.AccountName
  );

  return (
    <FlyoutHeader
      title={holding.Name}
      subtitle={subtitle}
      onClose={onClose}
    />
  );
};

export default React.memo(HoldingHeader);
